import type { SupabaseConfig } from './types';

export const LOCAL_SUPABASE_URL = 'http://127.0.0.1:54321';
export const LOCAL_SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxvY2FsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjMyNjAzNjAsImV4cCI6MTc5NDc5NjM2MH0._5cDc7THWtm0koU7UCFaQywBYI9Hmfyco-CS_VfpJ1w';

export const DEFAULT_SUPABASE_CONFIG: SupabaseConfig = {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
  },
  realtime: {
    params: {
      eventsPerSecond: 100, // Increased for chat app (from 10 to 100)
    },
    // Heartbeat settings to maintain connection
    heartbeatIntervalMs: 30000, // Send heartbeat every 30 seconds
    timeout: 20000, // Connection timeout after 20 seconds
    // Reconnection strategy with exponential backoff
    reconnectAfterMs: (tries: number) => {
      return Math.min(tries * 1000, 30000); // Max 30 seconds between retries
    },
  },
};
